import { render } from "./as-edit-block.vue?vue&type=template&id=31da381d&scoped=true&ts=true"
import script from "./as-edit-block.vue?vue&type=script&lang=ts"
export * from "./as-edit-block.vue?vue&type=script&lang=ts"

import "./as-edit-block.vue?vue&type=style&index=0&id=31da381d&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31da381d"]])

export default __exports__